export default [
  {
    to: { name: 'main' },
    icon: 'fas fa-home',
    text: 'Inicio'
  },
  {
    to: { name: 'programacion' },
    icon: 'fas fa-calendar',
    text: 'Programación'
  },
  {
    to: { name: 'libros' },
    icon: 'fas fa-book',
    text: 'Matutina'
  },
  {
    to: { name: 'contacto' },
    icon: 'fas fa-phone',
    text: 'Contacto'
  },
  {
    to: { name: 'donaciones' },
    icon: 'fas fa-hand-holding-usd',
    text: 'Donaciones'
  },
  {
    to: { name: 'blog', params: { url: 'https://blog.orionstereo.org/' } },
    icon: 'fas fa-blog',
    text: 'Blog'
  },
  {
    isLink: true,
    to: 'https://www.facebook.com/orionstereo/',
    icon: 'fab fa-facebook',
    text: 'Facebook'
  },
  {
    isLink: true,
    to: 'https://twitter.com/StereoOrion/',
    icon: 'fab fa-twitter',
    text: 'Twitter'
  },
  {
    isLink: true,
    to: 'https://www.instagram.com/orionstereo/',
    icon: 'fab fa-instagram',
    text: 'Instagram'
  }
]
